export default "__VITE_ASSET__BOtkT0cN__"